<a class="action" id="{{'menu-' + link.href}}" [routerLink]="link.href" [routerLinkActive]="'active'"
   [ngClass]="{'mobile': navigationService.useMobileNav$ | async, 'disabled':(link.availability | async) === FUINavigationLinkAvailability.DISABLED}">
    <div class="action-label" [class.mobile]="navigationService.useMobileNav$ | async">
        <div class="action-label-title" id="title">
            {{link.title | translate}}
        </div>
    </div>
    <div class="action-media" *ngIf="navigationService.useMobileNav$ | async">
        <fui-icon class="action-media-object" [height]="8" [icon]="'chevron-right'"
                  id="icon" [width]="6"></fui-icon>
    </div>
</a>
